import validate from "D:/App/Qrgateway.com/homepage_n3.2/node_modules/nuxt/dist/pages/runtime/validate.mjs";
export const globalMiddleware = [
  validate
]
export const namedMiddleware = {}